"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const uuid_1 = require("uuid");
const applyCommand_1 = require("../../applyCommand");
const applyForceComplete_1 = tslib_1.__importDefault(require("../../applyCommand/applyForceComplete"));
const executeEvaluateContent_1 = require("../../executeEvaluateContent");
const getState_1 = require("../../helpers/getState");
const command_1 = require("../../type/command");
const getCompletedCardContentIds_1 = require("./helpers/courseUpdated/getCompletedCardContentIds");
const getToCompleteContentIds_1 = require("./helpers/courseUpdated/getToCompleteContentIds");
function createForceCompleteCommand(command, rootContentId, toCompleteContentIds) {
    const { creatorId, timeStamp, userId } = command;
    return {
        type: command_1.CommandType.FORCE_COMPLETE,
        contentIds: toCompleteContentIds,
        creatorId,
        id: uuid_1.v4(),
        rootContentId,
        timeStamp,
        userId
    };
}
function ExecuteUpdateContentMutationForCourse(command, user, content, allParentContents, childContents, states, enrolments, stateInteractions) {
    const events = [];
    const { rootContentId, userId } = command;
    const rootState = getState_1.getStateByContentIdUserId(states, rootContentId, userId);
    const previousRootCompletionStatus = rootState.completionStatus;
    const completedCardIds = getCompletedCardContentIds_1.getCompletedCardContentIds(rootContentId, states);
    const UpdateContentMutationPayload = applyCommand_1.applyCommand(command, user, content, childContents, states, enrolments, stateInteractions);
    events.push(...UpdateContentMutationPayload.events);
    // Evaluating content based on normal evaluation mechanism
    const FirstEvaluationPayload = executeEvaluateContent_1.ExecuteEvaluateContent(command, user, content, allParentContents, childContents, UpdateContentMutationPayload.states);
    events.push(...FirstEvaluationPayload.events);
    // Fetching contentIds to forceComplete to maintain the completionStatus
    const toCompleteContentIds = getToCompleteContentIds_1.getToCompleteContentIds(content, FirstEvaluationPayload.states, previousRootCompletionStatus, completedCardIds);
    // forceCompleting the contentIds fetched above
    const forceCompleteCommand = createForceCompleteCommand(command, content._id, toCompleteContentIds);
    const ForceCompleteMutationPayload = applyForceComplete_1.default(forceCompleteCommand, user, content, childContents, FirstEvaluationPayload.states);
    events.push(...ForceCompleteMutationPayload.events);
    // Reevaluating the content based on forceComplete command applied above
    const SecondEvaluationPayload = executeEvaluateContent_1.ExecuteEvaluateContent(command, user, content, allParentContents, childContents, ForceCompleteMutationPayload.states);
    events.push(...SecondEvaluationPayload.events);
    return {
        events,
        states: SecondEvaluationPayload.states,
        enrolments: UpdateContentMutationPayload.enrolments,
        stateInteractions: UpdateContentMutationPayload.stateInteractions
    };
}
exports.ExecuteUpdateContentMutationForCourse = ExecuteUpdateContentMutationForCourse;
//# sourceMappingURL=ExecuteUpdateContentMutationForCourse.js.map